/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_ProviderInputs */

const en_settings_billing_provider = /** @type {(inputs: Settings_Billing_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

const zh_settings_billing_provider = /** @type {(inputs: Settings_Billing_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支付方式`)
};

/**
* | output |
* | --- |
* | "Provider" |
*
* @param {Settings_Billing_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_provider = /** @type {((inputs?: Settings_Billing_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_provider(inputs)
	return zh_settings_billing_provider(inputs)
});
export { settings_billing_provider as "settings.billing.provider" }